import * as types from '../mutation-types'

const state = {
  reloadList: 0
}

const getters = {
  [types.MEMBER.reloadList]: (state, getters) => {
    return state.reloadList;
  }
}

const mutations = {
  [types.MEMBER.reloadList] (state, flag) {
    state.reloadList = Date.now();
  }
}

export default {
  state,
  getters,
  mutations
}
